import { Lightbox } from "../modules/lightbox";
import { Slider } from "../modules/slider";

const gallerySections = document.querySelectorAll(".gallery-lightbox");

if (gallerySections.length > 0) {
    gallerySections.forEach(section => {
        const lightbox = new Lightbox({
            el: section,
        });
        const slider = new Slider({
            el: section,
            loop: true,
            blockLastSlides: false,
            breakpoints: {
                0: {
                    slidesPerView: 1.5,
                    marginRight: 8,
                },
                992: {
                    destroy: true,
                },
            },
        });
    });
}